import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import {
  clearAccessTokenGetter,
  getAuthAudience,
  getAuthScope,
  setAccessTokenGetter,
  setStoredAccessToken,
} from "../../utils/authTokenService";

const AuthTokenBridge = () => {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    setAccessTokenGetter(async ({ forceRefresh = false } = {}) => {
      const token = await getAccessTokenSilently({
        cacheMode: forceRefresh ? "off" : "on",
        authorizationParams: {
          audience: getAuthAudience(),
          scope: getAuthScope(),
        },
      });
      setStoredAccessToken(token);
      return token;
    });

    return () => {
      clearAccessTokenGetter();
    };
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (isLoading || !isAuthenticated) return;

    getAccessTokenSilently({
      authorizationParams: {
        audience: getAuthAudience(),
        scope: getAuthScope(),
      },
    })
      .then(setStoredAccessToken)
      .catch(() => {});
  }, [getAccessTokenSilently, isAuthenticated, isLoading]);

  return null;
};

export default AuthTokenBridge;
